import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    emoji: '⚽',
    question: '¿Para quién es este producto?',
    answer: 'Este producto está pensado para jóvenes futbolistas y sus padres que quieren ayudar a sus hijos a fortalecer su mentalidad, gestionar la presión y desarrollar hábitos que los acompañen dentro y fuera de la cancha.'
  }, {
    emoji: '👦',
    question: '¿Para qué edades sirve?',
    answer: 'Es ideal para padres de niños y adolescentes que juegan al fútbol, especialmente desde edades en las que ya empiezan a vivir competencia, presión, frustración o miedo a equivocarse. Sin embargo, es útil para cualquier edad.'
  }, {
    emoji: '🧠',
    question: '¿Qué aprenderá mi hijo con este material?',
    answer: 'Aprenderá herramientas clave para trabajar aspectos como la confianza, la resiliencia, el manejo de errores, la concentración, la motivación y la fortaleza mental en el fútbol.'
  }, {
    emoji: '📚',
    question: '¿En qué formato viene?',
    answer: 'Viene en formato digital, para que lo puedas descargar y consultar desde tu móvil, tablet u ordenador.'
  }, {
    emoji: '🛡️',
    question: '¿Tiene garantía?',
    answer: 'Sí. Tu compra queda respaldada por la garantía indicada en esta misma página de venta.'
  }, {
    emoji: '📖',
    question: '¿Qué temas aborda este producto?',
    answer: 'Aborda temas fundamentales como presión competitiva, confianza, disciplina, resiliencia, motivación, manejo del error, concentración, visualización y apoyo familiar.'
  }, {
    emoji: '🏠',
    question: '¿Puedo usar este material en casa, aunque mi hijo entrene en un club?',
    answer: 'Sí. De hecho, está pensado para complementar lo que vive en el club y ayudarte a reforzar desde casa hábitos mentales positivos que muchas veces no se trabajan en profundidad.'
  }, {
    emoji: '😔',
    question: '¿Qué pasa si mi hijo está desmotivado o frustrado con el fútbol?',
    answer: 'Este material puede ayudarte a comprender mejor lo que está viviendo y a acompañarlo con herramientas más útiles. Es ideal para momentos en los que el niño siente miedo al error, frustración, ansiedad o falta de confianza.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-brand-cream-dark" data-id="element-29">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-12" data-id="element-31">
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-4" data-id="element-32">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-brand-amber mx-auto rounded-full" data-id="element-33"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-34">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="bg-white rounded-xl shadow-sm border border-brand-slate/5 overflow-hidden" data-id="element-35">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 sm:px-6 py-4 sm:py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-36">
                <span className="font-bold text-brand-slate flex items-center gap-2 sm:gap-3" data-id="element-37">
                  <span className="text-xl flex-shrink-0" data-id="element-38">{faq.emoji}</span>
                  <span data-id="element-39">{faq.question}</span>
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-slate-light transition-transform duration-300 flex-shrink-0 ml-2 sm:ml-4 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-40" />
              </button>

              <AnimatePresence data-id="element-41">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-42">
                    <div className="px-4 sm:px-6 pb-4 sm:pb-5 pt-0 text-brand-slate-light pl-12 sm:pl-14 text-sm sm:text-base" data-id="element-43">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}